import config from '@/components/settings/config/storage';
import googleAccount from '@/components/settings/googleAccount/storage';
import demandCountries from '@/components/settings/demandCountries/storage';
import emailAlert from '@/components/settings/emailAlert/storage';
import countries from '@/components/settings/countries/storage';
import languages from '@/components/settings/languages/storage';

export default {
    namespaced: true,
    modules: {
        config,
        googleAccount,
        demandCountries,
        emailAlert,
        countries,
        languages,
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}